export interface Props<T> {
  items: T[];
  itemsPerPage: number;
  page: number;
}

export const getPaginatedItems = <T>({ items, itemsPerPage, page }: Props<T>) => {
  const start = (page - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return items.slice(start, end);
};
